"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.form.title.edit': 'Modifica Azienda',
    'company.form.title.add': 'Aggiungi Azienda',
    'company.form.back': 'Indietro',
    'company.form.name.label': 'Nome Azienda',
    'company.form.name.placeholder': 'Inserisci nome azienda',
    'company.form.nip.label': 'P.IVA',
    'company.form.nip.placeholder': '123-456-78-90',
    'company.form.email.label': 'Email',
    'company.form.email.placeholder': 'indirizzo@email.com',
    'company.form.phone.label': 'Telefono',
    'company.form.phone.placeholder': '123 456 789',
    'company.form.address.label': 'Indirizzo',
    'company.form.street.placeholder': 'Via e numero',
    'company.form.postal_code.placeholder': 'Codice postale',
    'company.form.city.placeholder': 'Città',
    'company.form.website.label': 'Sito web',
    'company.form.website.placeholder': 'https://azienda.com',
    'company.form.description.label': 'Descrizione',
    'company.form.description.placeholder': 'Descrizione azienda',
    'company.form.active.label': 'Attiva',
    'company.form.logo.label': 'Logo Azienda',
    'company.form.logo.placeholder': 'Seleziona logo azienda',
    'company.form.submit.update': 'Aggiorna',
    'company.form.submit.create': 'Salva',
    'company.form.submit.createCompanyData': 'Salva Dati Azienda',
    'company.form.acl.loadError': 'Errore nel caricamento dei metadati ACL:',
    'company.form.load.error': 'Errore nel caricamento dell\'azienda',
    'company.form.submit.updateError': 'Errore nell\'aggiornamento dell\'azienda',
    'company.form.submit.createError': 'Errore nella creazione dell\'azienda',
    'company.form.submit.updateSuccess': 'Azienda aggiornata con successo',
    'company.form.submit.createSuccess': 'Azienda creata con successo',
};
